import { gql } from '@apollo/client';

export const LOG_LIST_QUERY = gql`
  query logs($pager: PagerInputNew!, $filters: LogFilterInput) {
    logs(pager: $pager, filters: $filters) {
      total
      values {
        id
        message
        level
        timeStamp
        exception
        logEvent
        correlationId
      }
    }
  }
`;

export const LOG_QUERY = gql`
  query log($logId: String!) {
    log(logId: $logId) {
      id
      message
      level
      timeStamp
      exception
      logEvent
      correlationId
    }
  }
`;
export const LOG_LEVELS_QUERY = gql`
  query logLevels {
    logLevels {
      id
      name
    }
  }
`;
